export const rydeColors = {
  white: "#FFFFFF",
  smoke: "#F8F9FA",
  black: "#000000",
  blueTimeEditBg: "#f5fbff",
  skyBlue: "#93C3E3",
  redTimeEditBg: "#fff1f0",
  greyFocusedInput: "#212529",
  whiteButtonBorder: "#CFD8DC",
  dragBorderColor: "#b388ff",
  gridCellHover: "#F7F8FA",
  grey: "#979797",
  softGray: "#c4c4c4",
  /* A muted pastel family, light enough to carry dark text on a filled chip or a chart arc. */
  softCoral: "#F09B92",
  softAmber: "#F5C48A",
  softSlate: "#D3D9E0",
  softAzure: "#A5C9EE",
  softMint: "#96D6B6",
  lightGreyBorder: "#edeff7",
  lightGrey: "#e4e3e3",
  lightBlue: "#69A2E4",
  lightGreen: "#40E098",
  yellow: "#EED600",
  highlightSearch: "#fff39f",
  orange: "#FF8A00",
  steel: "#3D70B2",
  darkSteel: "#2a5184",
  placeholder: "#233740",
  green: "#059A8F",
  red: "#F00",
  brandRed: "#FF0000",
  rowHighlight: "#F3F3FE",
  searchFilterFieldBackgroundError: "#fff8f8",
  darkBlue: "#607d8b",
  previewNumberColor: "#7b61ff",
  selectedBookingCalendarBackground: "#efefff",
  focusedOption: "#DEEBFF",
  focusedControl: "#86b7fe",
  greyBorderButton: "#AAAAAA",
  bgColorLogin: "#140B4E",
  bgColorLoginAdmin: "#2c2c2c",
  purpleTitle: "#4A209C",
  bulkPrintHeader: "#f2f5f7",
  leftMenuHighlight: "#40E098",
  userNotMeToday: "#E8C1EE",
  userMeNotToday: "#A393EA",
  bookingPastCalendarCells: "#f6f8fa",
  reactSelectBlue: "#2684ff",
  passOutOrange: "#FF6E40",
  passInBlue: "#448AFF",
  additionsSwitchBgColor: "#1890ff",
  leftNavPlusButtonBgColor: "#7b61ff",
  leftNavPlusButtonBgHoverColor: "#1E0C70",
  greenishTeal: "#35bf82",
  thujaGreen: "#17620b",
  lightThujaGreen: "#45873bff",
  princetonOrange: "#ff8e00",
  mochaccino: "#935002",
  neonBoneyard: "#dcc9ff",
  venetianNights: "#7b61ff",
  iridescentPurple: "#9a7ccf",
  crisisRed: "#bb2424",
  goryRed: "#a20606",
  redBlood: "#650303",
  electricPink: "#EA80FC",
  vividPurple: "#AA00FF",
  brightVividPurple: "#B961FF",
  princetonPurple: "#4A209C",
  midGrey: "#616161",
  viewOptionHover: "#F1E7FF",
  yellowButton: "#e0ad05",
  yellowButtonHover: "#c9a327",
  stationRouteBannerBackground: "#FEF3E0",
  stationRouteBannerText: "#E5743F",
  stationRouteHistoryAccent: "#fff59d",
  adminToolsCautionText: "#5c3d00",
  peachCoral: "#FFB09C",
  googleAttributes: "#666",
  darkerRed: "#D90026",
  // Non-production navbar/login UI: orange (main app) / green (admin). Darker shades for hover, tooltips, login CTA variants.
  nonProductionNavbarOrange: "#FF8A00",
  nonProductionNavbarOrangeHover: "#CC6E00",
  nonProductionNavbarOrangeDark: "#993800",
  nonProductionNavbarOrangeDarker: "#7A2D00",
  nonProductionNavbarGreen: "#1B5E20",
  nonProductionNavbarGreenHover: "#0D3D10",
  passengerMaleSelected: "#7b61ff",
  passengerFemaleSelected: "#FF8A00",
  passengerMaleUnselected: "#7b61ff",
  passengerFemaleUnselected: "#ff9100",
  liveMapIncidentSecurity: "#E91E8C",
  liveMapDebugIncidentPurple: "#9C27B0",
  liveMapDebugIncidentRepair: "#B71C1C",
  liveMapDebugIncidentRideEvent: "#FB8C00",
  liveMapDebugIncidentRoadBlock: "#EF6C00",
  liveMapDebugIncidentAlternateRepair: "#E53935",
  liveMapDebugIncidentAlternateRideEvent: "#FFA726",
  liveMapDebugIncidentAlternateRoadBlock: "#FF7043",
  reportChartBar: "#30cd89",
  reportChartAxisTitle: "#7b1fa2",
} as const;

export const rydeColorsDashboardPage = {
  contentBackground: "#e0e0e0",
  cardHeaderColor: "#333333",
  dashboardCardBorder: "#CCCCCC",
  dateTextColor: "#212121",
  alertSecondaryText: "#aaaaaa",
  alertText: "#fe0000",
  dashboardHeaderBorderColor: "#c4c4c4",
  greenTextNumeric: "#29A96F",
  redTextNumeric: "#FF0000",
  greyTextNumeric: "#aaaaaa",
  numericSeparatorColor: "#D9D9D9",
  launchIconColor: "#979797",
};

export const rydeColorsGraphs = {
  barLabelTextColor: "#7B61FF",
  verticalBarDefaultColor: "#7B61FF",
  verticalBarRedColor: "#FF0000",
  horizontalBarDefaultColor: "#4A209C",
};

export const rydeColorsGraphsScheme = {
  Green: {
    Green1: "#006400",
    Green2: "#228B22",
    Green3: "#66B032",
    Green4: "#317873",
    Green5: "#355E3B",
    Green6: "#556B2F",
    Green7: "#004225",
    Green8: "#01796F",
    Green9: "#1B4D3E",
    Green10: "#059033",
    Green11: "#007947",
    Green12: "#4D5D53",
    Green13: "#1E4D2B",
    Green14: "#414833",
    Green15: "#4A5D23",
    Green16: "#195905",
    Green17: "#18453B",
    Green18: "#014421",
    Green19: "#21421E",
    Green20: "#39A78E",
    Green21: "#005D58",
    Green22: "#007F5C",
  },
  Red: {
    Red1: "#FF0000",
    Red2: "#8B0000",
    Red3: "#C80815",
    Red4: "#DC143C",
    Red5: "#B22222",
    Red6: "#CD5C5C",
    Red7: "#560319",
    Red8: "#C80815",
    Red9: "#C41E3A",
    Red10: "#E30B5D",
    Red11: "#5C0120",
    Red12: "#7F1734",
    Red13: "#4E0606",
    Red14: "#954535",
    Red15: "#A40000",
    Red16: "#73000A",
    Red17: "#742244",
    Red18: "#4A0404",
    Red19: "#E60026",
    Red20: "#92000A",
    Red21: "#800000",
    Red22: "#E0115F",
    Red23: "#660000",
    Red24: "#66023C",
    Red25: "#CC4E5C",
    Red26: "#D40000",
    Red27: "#CE2029",
    Red28: "#E62020",
    Red29: "#990000",
  },
  Purple: {
    Purple1: "#7B61FF",
    Purple2: "#4A209C",
    Purple3: "#551A8B",
    Purple4: "#4B0082",
    Purple5: "#9932CC",
    Purple6: "#663399",
    Purple7: "#8A2BE2",
    Purple8: "#7851A9",
    Purple9: "#702963",
    Purple10: "#66023C",
    Purple11: "#78184A",
    Purple12: "#6F2DA8",
    Purple13: "#32174D",
    Purple14: "#682860",
    Purple15: "#880085",
    Purple16: "#6C3082",
    Purple17: "#800080",
    Purple18: "#301934",
    Purple19: "#BA55D3",
    Purple20: "#9966CC",
    Purple21: "#734F68",
    Purple22: "#E0B0FF",
    Purple23: "#9678B6",
    Purple24: "#9370DB",
    Purple25: "#483D8B",
    Purple26: "#8B008B",
    Purple27: "#8B00FF",
    Purple28: "#6F00FF",
    Purple29: "#9400D3",
  },
};
